import { ACCOUNT_SECTIONS, DEFAULT_MODULE, ROUTES } from '@/app/routes';
import { REGEX } from '@/config/regex.constants';

// An activity's `ctaButton.url` is an iscc-frontend path; only targets with a screen here resolve.

const REDIRECT = 'REDIRECT';

const ACCOUNT_SECTION_BY_LEGACY = Object.freeze({
  myProfile: ACCOUNT_SECTIONS.companyProfile,
  materialSettings: ACCOUNT_SECTIONS.materials,
  systemSettings: ACCOUNT_SECTIONS.systemSettings,
});

const LIST_ROUTE_BY_PATH = Object.freeze({
  '/contracts': ROUTES.contracts,
  '/shipments': ROUTES.incomingShipments,
  '/inventory': ROUTES.inventory,
  '/transactions': ROUTES.transactions,
});

const PENDING_ORDERS_TAB = 'pending_orders';
const ACCESS_MANAGER_TAB = 'accessManager';

// Detail links carry display codes (`contract_id`, `rsa_id`), not the db ids our routes take.
export const resolveActivityLink = (cta, module = DEFAULT_MODULE) => {
  if (cta?.actionType !== REDIRECT || !cta.url) return null;

  const [path, query = ''] = cta.url.split('?');
  const params = new URLSearchParams(query);

  if (path === '/account') {
    const section = ACCOUNT_SECTION_BY_LEGACY[params.get('section')];
    return section ? ROUTES.accountSetup(section) : null;
  }
  if (path === '/adminCenter') {
    return params.get('tab') === ACCESS_MANAGER_TAB ? ROUTES.admin : null;
  }
  if (path === '/outbounds' || path === '/operations') {
    return params.get('tab') === PENDING_ORDERS_TAB ? ROUTES.orders(module) : null;
  }

  const site = path.match(REGEX.LEGACY_SITE_PATH);
  if (site) return ROUTES.siteDetail(site[1]);

  return LIST_ROUTE_BY_PATH[path]?.(module) ?? null;
};
